import { spacer8, spacer48 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { Type } from "../Type";
export var Title = styled(Type).attrs({
  forwardedAs: 'h1',
  variant: 'cello'
}).withConfig({
  displayName: "Title",
  componentId: "bugxpe-0"
})(["padding-block-end:", ";padding-inline-end:", ";"], spacer8, spacer48);